<div class="page-wrapper min-vh-100 bg-light">
  <InactivityModal />

  <div class="vh-100 d-flex flex-column bg-gray overflow-hidden">
    <Navbar
      @sidebar-toggle="toggleSidebar"
      class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0"
    />

    <div class="container-fluid flex-grow-1 overflow-hidden">
      <div class="row h-100">
        <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
          <div class="mt-2">
            <Sidebar ref="sidebar" />
          </div>
        </div>

        <div class="col h-100 overflow-auto mt-2">
          <div class="bg-gray px-2 py-1 h-100 scrollable-container mb-5">
            <main
              v-if="loading_incident_types"
              class="text-center py-5 w-100"
            >
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Incident Types...</p>
            </main>

            <main v-else class="pb-extra">
              <div class="card bg-transparent mt-3 rounded border-0">
                <div class="card-body px-0">
                  <div class="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
                    <div class="d-flex align-items-center gap-2">
                      <button
                        class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#dashboardSidebarOffcanvas"
                        aria-controls="dashboardSidebarOffcanvas"
                        aria-label="Open workspace menu"
                      >
                        <i class="bx bx-menu-alt-left fs-5"></i>
                      </button>
                      <div>
                        <h5 class="fw-bold text-dark mb-0">Incident Types</h5>
                      </div>
                    </div>
                    <button type="button" class="btn btn-sm bg-primary text-white rounded shadow" @click="open_type_form()">
                      Create incident type
                    </button>
                  </div>

                  <p class="fs-xsm text-dark mb-4">
                    Categories residents can choose when logging a new incident.
                  </p>

                  <div class="row g-3 mb-4">
                    <div class="col-6 col-lg-3">
                      <div class="card h-100 border shadow-sm rounded">
                        <div class="card-body d-flex align-items-center justify-content-between p-3 p-md-4">
                          <div>
                            <p class="small text-muted fw-semibold text-uppercase mb-1">Total types</p>
                            <h3 class="fw-bold mb-0">{{ incident_types.length }}</h3>
                          </div>
                          <span class="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary marketplace-thumb-placeholder">
                            <i class="bi bi-grid-fill fs-4"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <teleport to="body">
                    <div
                      id="incidentTypeModal"
                      ref="incidentTypeModal"
                      class="modal fade"
                      tabindex="-1"
                      role="dialog"
                      aria-modal="true"
                      aria-labelledby="incidentTypeModalTitle"
                    >
                      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                        <div class="modal-content border-0 rounded shadow">
                      <div class="modal-header bg-white d-flex align-items-center justify-content-between gap-3 p-4">
                        <div>
                          <h5 id="incidentTypeModalTitle" class="fw-bold mb-1">{{ editing_type_id ? 'Update incident type' : 'Create incident type' }}</h5>
                          <p class="text-muted text-xxs mb-0">Choose the name, icon and display colour.</p>
                        </div>
                        <button type="button" class="btn btn-light rounded-circle" aria-label="Close modal" @click="close_type_form">
                          <i class="bi bi-x-lg"></i>
                        </button>
                      </div>
                      <div class="modal-body p-4">
                        <div class="row g-3">
                          <div class="col-12">
                            <label class="form-label text-xxs fw-bold">Name <span class="text-danger">*</span></label>
                            <input
                              ref="typeNameInput"
                              v-model="type_form.name"
                              type="text"
                              class="form-control rounded text-xxs"
                              :class="{ 'is-invalid': form_errors.name }"
                              placeholder="e.g. Telecommunications"
                              @input="form_errors.name = ''"
                            />
                            <div v-if="form_errors.name" class="text-danger text-xxs mt-1">{{ form_errors.name }}</div>
                          </div>
                          <div class="col-12">
                            <label class="form-label text-xxs fw-bold d-block mb-1">Choose icon</label>
                            <p class="text-muted text-xxs mb-3">Select an icon below, or upload your own custom image.</p>
                            <div class="d-flex flex-wrap align-items-start gap-3">
                              <button
                                v-for="icon_option in available_icons"
                                :key="icon_option.value"
                                type="button"
                                class="btn border rounded d-inline-flex flex-column align-items-center justify-content-center gap-1 p-2 incident-type-icon-option"
                                :class="{ 'btn-light': !is_icon_option_selected(icon_option), 'is-selected': is_icon_option_selected(icon_option) }"
                                :aria-pressed="is_icon_option_selected(icon_option)"
                                :aria-label="icon_option.name"
                                :title="icon_option.name"
                                @click="select_icon_option(icon_option)"
                              >
                                <img
                                  v-if="icon_option.uploaded"
                                  :src="file_to_url(icon_option.value)"
                                  :alt="icon_option.name"
                                  class="incident-type-uploaded-icon"
                                />
                                <i v-else class="bi fs-5" :class="icon_option.value"></i>
                              </button>
                            </div>
                            <div class="mt-3">
                              <button
                                type="button"
                                class="btn rounded d-inline-flex flex-column align-items-center justify-content-center gap-1 p-3 incident-type-icon-upload"
                                title="Upload a new icon"
                                @click="$refs.incidentIconInput.click()"
                              >
                                <i class="bi bi-cloud-arrow-up incident-type-upload-icon" aria-hidden="true"></i>
                                <span class="incident-type-upload-title text-xxs fw-semibold">Upload your own icon</span>
                                <span class="text-muted text-xxxs fw-normal">PNG, JPG or SVG</span>
                              </button>
                              <input
                                ref="incidentIconInput"
                                type="file"
                                class="d-none"
                                accept="image/png,image/jpeg,image/svg+xml"
                                @change="handle_icon_upload"
                              />
                            </div>
                          </div>
                          <div class="col-12">
                            <label class="form-label text-xxs fw-bold d-block">Choose colour <span class="text-danger">*</span></label>
                            <div class="d-flex align-items-center gap-3">
                              <label
                                class="incident-type-color-picker position-relative d-inline-flex align-items-center justify-content-center border rounded cursor-pointer overflow-hidden"
                                :data-incident-color="type_form.color"
                                data-incident-bg-color
                                title="Choose icon color"
                              >
                                <input
                                  v-model="type_form.color"
                                  type="color"
                                  class="incident-type-color-input position-absolute top-0 start-0 w-100 h-100 cursor-pointer opacity-0"
                                  aria-label="Choose icon color"
                                  @input="handle_type_color_input"
                                />
                                <i class="bi bi-eyedropper text-white fs-5 incident-type-eyedropper"></i>
                              </label>
                              <input
                                v-model="type_form.color"
                                type="text"
                                class="form-control text-xxs incident-type-color-text"
                                :class="{ 'is-invalid': form_errors.color }"
                                maxlength="7"
                                aria-label="Selected hex color"
                                @input="handle_type_color_input"
                              />
                              <span class="text-muted text-xxs">Choose any colour</span>
                            </div>
                            <div v-if="form_errors.color" class="text-danger text-xxs mt-1">{{ form_errors.color }}</div>
                          </div>
                          <div class="col-12">
                            <div class="d-flex align-items-center gap-3 border rounded bg-light p-3">
                              <span
                                class="d-inline-flex align-items-center justify-content-center rounded-circle marketplace-thumb-placeholder"
                                :data-incident-color="type_form.color"
                                data-incident-icon-color
                              >
                                <img
                                  v-if="type_form.file"
                                  :src="file_to_url(type_form.file)"
                                  alt="Selected incident type icon"
                                  class="incident-type-uploaded-icon"
                                />
                                <i v-else class="bi fs-4" :class="type_form.icon"></i>
                              </span>
                              <div>
                                <p class="text-xxs fw-bold mb-0">Preview</p>
                                <span class="text-muted text-xxs">{{ type_form.name || 'Incident type name' }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer bg-white d-flex justify-content-end gap-2 p-3">
                          <button
                            type="button"
                            class="btn btn-sm bg-primary text-white rounded shadow"
                            :disabled="saving_incident_type"
                            @click="save_type"
                          >
                            <div v-if="saving_incident_type">
                              <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                              Saving...
                            </div>
                            <div v-else>Save</div>
                          </button>
                      </div>
                        </div>
                      </div>
                    </div>
                  </teleport>

                  <teleport to="body">
                    <div id="assignAuthorityModal" class="modal fade" tabindex="-1" aria-hidden="true">
                      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                        <div class="modal-content border-0 rounded shadow">
                          <div class="modal-header bg-white d-flex align-items-center justify-content-between gap-3 p-4">
                            <div>
                              <h5 class="fw-bold mb-1">Assign authority</h5>
                              <p class="text-muted text-xxs mb-0">
                                Choose who handles {{ assigning_incident_type?.name || 'incident' }} reports.
                              </p>
                            </div>
                            <button type="button" class="btn btn-light rounded-circle" aria-label="Close modal" @click="close_assign_modal">
                              <i class="bi bi-x-lg"></i>
                            </button>
                          </div>

                          <div class="modal-body p-4">
                            <div class="position-relative mb-3">
                              <i class="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                              <input
                                v-model="authority_search"
                                type="search"
                                class="form-control rounded ps-5 text-xxs"
                                placeholder="Search people or departments..."
                                aria-label="Search people or departments"
                              />
                            </div>

                            <div class="incident-authority-list overflow-y-auto pe-1">
                              <button
                                v-for="authority in filtered_authorities"
                                :key="authority.id"
                                type="button"
                                class="btn d-flex align-items-center gap-3 w-100 text-start border rounded p-2 mb-2"
                                :class="selected_authority_ids.includes(authority.id) ? 'bg-primary-subtle' : 'bg-white'"
                                @click="toggle_authority(authority.id)"
                              >
                                <span
                                  class="incident-authority-avatar d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white fw-bold flex-shrink-0"
                                >{{ authority.initials }}</span>
                                <span class="flex-grow-1 overflow-hidden">
                                  <span class="d-block fw-bold text-dark text-xxs">{{ authority.name }}</span>
                                  <span class="d-block text-muted text-truncate text-xxs">{{ authority.department }}</span>
                                </span>
                                <input
                                  class="form-check-input flex-shrink-0"
                                  type="checkbox"
                                  :value="authority.id"
                                  v-model="selected_authority_ids"
                                  tabindex="-1"
                                  @click.stop
                                />
                              </button>

                              <div v-if="!filtered_authorities.length" class="text-center text-muted text-xxs py-4">
                                No people or departments found.
                              </div>
                            </div>
                          </div>

                          <div class="modal-footer bg-white d-flex justify-content-end gap-2 p-3">
                            <button type="button" class="btn btn-sm btn-light border rounded" @click="close_assign_modal">Cancel</button>
                            <button
                              type="button"
                              class="btn btn-sm bg-primary text-white rounded shadow"
                              :disabled="!has_authority_changes || assigning_incident_type_id !== null"
                              @click="assign_authority"
                            >
                              <div v-if="assigning_incident_type_id !== null">
                                <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                                Saving...
                              </div>
                              <div v-else>Assign</div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </teleport>

                  <div class="card border shadow-sm rounded">
                    <div class="card-header bg-white border-0 d-flex flex-wrap align-items-center justify-content-between gap-3 p-4 rounded">
                      <div>
                        <h5 class="fw-bold mb-1">Available incident types</h5>
                        <p class="text-muted text-xxs mb-0">Icons and categories are configured in this page.</p>
                      </div>
                    </div>

                    <div class="table-responsive px-3 px-lg-4 pb-3 pb-lg-4">
                      <table id="incident-types-table" class="table align-middle mb-0 w-100">
                        <thead class="btn-primary text-white">
                          <tr class="small text-muted">
                            <th class="py-3">Incident type</th>
                            <th class="py-3">Icon</th>
                            <th class="py-3">Colour</th>
                            <th class="py-3">Assigned to</th>
                            <th class="px-4 py-3 text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="type in filtered_incident_types" :key="type.id">
                            <td>
                              <div class="fw-semibold text-dark">{{ type.name }}</div>
                            </td>
                            <td>
                              <span
                                class="d-inline-flex align-items-center justify-content-center rounded marketplace-thumb-placeholder"
                                :data-incident-color="type.color"
                                :title="type.file ? 'Custom file' : type.icon"
                                data-incident-icon-color
                              >
                                <img
                                  v-if="type.file"
                                  :src="type.file.file_url"
                                  :alt="`${type.name} icon`"
                                  class="incident-type-uploaded-icon"
                                />
                                <i v-else class="bi fs-4" :class="type.icon" :aria-label="`${type.name} icon`"></i>
                              </span>
                            </td>
                            <td>
                              <div class="d-inline-flex align-items-center gap-2">
                                <span
                                  class="incident-type-color-dot d-inline-block rounded-circle border"
                                  :data-incident-color="type.color"
                                  data-incident-bg-color
                                ></span>
                                <span class="small fw-semibold text-uppercase">{{ type.color }}</span>
                              </div>
                            </td>
                            <td>
                              <div v-if="get_assigned_authorities(type).length" class="d-flex flex-column gap-2">
                                <div
                                  v-for="authority in get_assigned_authorities(type)"
                                  :key="authority.id"
                                  class="d-flex align-items-center gap-2"
                                >
                                  <span
                                    class="d-inline-flex align-items-center justify-content-center rounded-circle text-white fw-bold flex-shrink-0 text-xxxs w-30px h-30px bg-primary"
                                  >{{ authority.initials }}</span>
                                  <div class="overflow-hidden">
                                    <div class="small fw-semibold text-dark text-truncate">{{ authority.name }}</div>
                                    <div class="text-muted text-xxxs text-truncate">{{ authority.department }}</div>
                                  </div>
                                </div>
                              </div>
                              <span v-else class="badge bg-light text-muted border fw-normal">Unassigned</span>
                            </td>
                            <td class="px-4 text-end">
                              <div class="d-inline-flex align-items-center gap-2">
                                <button type="button" class="btn btn-light btn-sm rounded-3 text-success border text-xxs" :aria-label="`Edit ${type.name}`" @click="open_type_form(type)">
                                 Edit
                                </button>
                                <button type="button" class="btn btn-light btn-sm rounded-3 text-secondary border text-xxs" :aria-label="`Assign authority for ${type.name}`" @click="open_assign_modal(type)">
                                 Assign
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-light btn-sm rounded-3 text-danger border text-xxs"
                                  :disabled="deleting_incident_type_id === type.id"
                                  :aria-label="`Delete ${type.name}`"
                                  @click="delete_type(type)"
                                >
                                  <span v-if="deleting_incident_type_id === type.id" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                                  {{ deleting_incident_type_id === type.id ? 'Deleting...' : 'Delete' }}
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
